import {
  B2B_USER_FAILED,
  B2B_USER_SUCCESS,
  B2B_PROFILE_IMAGE_UPDATE,
} from '../../Helpers/Constant';
import {
  initialState,
  TB2BUSER,
} from '../../Context/AuthContex/B2BAuthContext';

const b2bReducer = (state: TB2BUSER, action: any): TB2BUSER => {
  switch (action.type) {
    case B2B_USER_SUCCESS:
      return {
        ...state,
        b2bUser: action.payload,
      };
    case B2B_PROFILE_IMAGE_UPDATE:
      const updateUser = { ...state.b2bUser, ...action.payload };
      return { ...state, b2bUser: updateUser };
    case B2B_USER_FAILED:
      localStorage.removeItem('toab_fair');
      return { ...state, b2bUser: initialState.b2bUser }; // Reference `initialState` here
    default:
      throw new Error(`No matching action type - ${action.type}`);
  }
};

export default b2bReducer;
